'use client'

import { Fragment } from 'react'

import { TFAQ } from '@/entities/support'
import { usePagination } from '@/shared/lib'
import { Pagination, Separator } from '@/shared/ui'
import { FAQAnswer } from '@/widgets/faq'

import * as Accordion from './accordion'

type Props = {
  faqs: TFAQ[]
  lastPage?: number
  showPagination?: boolean
}

export const FAQList = ({
  faqs,
  lastPage = 1,
  showPagination = true,
}: Props) => {
  const { page, handlePageChange } = usePagination()

  return (
    <>
      <Accordion.Root type="multiple" className="mb-10">
        {faqs.map((faq, index) => (
          <Fragment key={faq.id}>
            <Accordion.Item value={faq.id.toString()}>
              <Accordion.Trigger>
                <span className="typo-title3 h-9 w-4.5 font-medium text-purple-300">
                  Q
                </span>
                <div className="flex-1 space-y-1.5 py-[9px] text-left">
                  <div className="typo-label2 font-bold text-gray-400">
                    {faq.categoryName}
                  </div>
                  <p className="typo-body1 font-semibold text-gray-900">
                    {faq.question}
                  </p>
                </div>
              </Accordion.Trigger>
              <Accordion.Content>
                <div className="bg-gray-0 ml-8.5 flex gap-6 p-6">
                  <span className="typo-title3 h-9 font-medium text-gray-200">
                    A
                  </span>
                  <FAQAnswer
                    className="typo-body1-reading self-center whitespace-break-spaces text-gray-900"
                    html={faq.answer}
                  />
                </div>
              </Accordion.Content>
            </Accordion.Item>
            {index !== faqs.length - 1 && <Separator className="my-5" />}
          </Fragment>
        ))}
      </Accordion.Root>
      {showPagination && (
        <Pagination
          current={page}
          total={lastPage}
          onPageChange={handlePageChange}
        />
      )}
    </>
  )
}
